import { IDocument, IFolder } from 'interfaces';
import { choosenDocument } from 'store/slices/dataDocumentsSlice';

export const getRightNameofEntity = (selectedEntities: choosenDocument[], entityOfContextMenu: IDocument | IFolder | null) => {
  const target = selectedEntities[0] || entityOfContextMenu;
  
  if (!target) return 'file';
  
  if (selectedEntities.length > 1) return 'objects';
  
  return String(target.key)?.includes('folder') ? 'folder' : 'file';
};

type TreeNode = {
  key: string;
  children?: TreeNode[];
};

// Находит узел по ключу
const findNode = (nodes: TreeNode[], key: string): TreeNode | null => {
  for (const node of nodes) {
    if (node.key === key) return node;
    if (node.children) {
      const found = findNode(node.children, key);
      if (found) return found;
    }
  }
  return null;
};

/**
 * Проверяет, является ли targetFolder дочерней папкой
 * по отношению к любой из choosenFolders.
 */
export function isChildOfChosen(
  treeData: TreeNode[],
  choosenFolders: string[],
  targetFolder: string
): boolean {

  // Проверяет, есть ли targetFolder в поддереве node
  const containsTarget = (node: TreeNode | null, target: string): boolean => {
    if (!node) return false;
    if (node.key === target) return true;
    if (!node.children) return false;

    return node.children.some(child => containsTarget(child, target));
  };

  // Проверяем каждую выбранную папку
  for (const folder of choosenFolders) {
    const node = findNode(treeData, folder);
    if (containsTarget(node, targetFolder)) {
      return true;
    }
  }

  return false;
}

export function isParentOfChosen(
  treeData: TreeNode[],
  choosenFolders: string[],
  targetFolder: string
): boolean {
  // Проверяет, есть ли folder в поддереве node
  const containsFolder = (node: TreeNode | null, folder: string): boolean => {
    if (!node) return false;
    if (node.key === folder) return true;
    if (!node.children) return false;

    return node.children.some(child => containsFolder(child, folder));
  };

  // Находим узел targetFolder
  const targetNode = findNode(treeData, targetFolder);
  if (!targetNode) return false;

  // Проверяем, является ли targetFolder родителем любой выбранной папки
  return choosenFolders.some(folder => containsFolder(targetNode, folder));
}

export function isTheSame(
  choosenFolders: string[],
  targetFolder: string
): boolean {
  // Если targetFolder совпадает с выбранной папкой → сразу true
  if (choosenFolders.includes(targetFolder)) {
    return true;
  }
  return false
}
